import React, { Component } from 'react';
import img from '../../../assets/Admin/Agency_Content/142bf7fe2b88ca521d02397f88943325_html_1e49bc8762800abb.png';
import img1 from '../../../assets/Admin/Agency_Content/142bf7fe2b88ca521d02397f88943325_html_60d03fc39e4f2ccc.png';
class AgencyContent extends Component {
    render() {
        return (
            <div className="mi_main">
                <p ><b > Invite Agency:</b></p>
                <p>User can invite new agencies to application from Agencies Invite Agency Feature. User enters Agency Details to invite a Agency.</p>
                <img width="100%" height="100%" style={{marginBottom:"50px"}} alt="example"  src={img1} />
                <p ><b > Register Agency:</b></p>
                <p>Invited Agencies registers to application by clicking on invitation link. Invitation link opens up registration  page, Agency enters details and set Username and Password for accessing application.</p>
                <img width="100%" height="100%" style={{marginBottom:"50px"}} alt="example"  src={img} />
            </div>
        )
    }
}
export default AgencyContent;
